import './emptyState.sass';
import calendario from '../../../../assets/calendar.png';
import sportFutbol from '../../../../assets/cancel-foot.png';
import sportBaloncesto from '../../../../assets/cancel-bask.png';
import sportFutbolAmericano from '../../../../assets/cancel-amfo.png';
import sportBeisbol from '../../../../assets/cancel-base.png';
import sportFormula1 from '../../../../assets/cancel-mtr.png';
import sportTenis from '../../../../assets/cancel-tns.png';

/**
 * Componente que muestra un mensaje cuando no hay eventos disponibles
 * Se muestra cuando se selecciona un deporte que no tiene eventos después de aplicar filtros
 * 
 * @param {Object} props
 * @param {string} props.selectedSport - Código del deporte seleccionado
 * @param {Object} props.filteredData - Datos filtrados de la tab actual
 * @param {boolean} props.isActive - Si la tab actual está activa
 */
export default function EmptyState({ selectedSport, filteredData, isActive }) {
  // Obtener el nombre del deporte seleccionado
  const SPORTS_MAP = {
    FOOT: { name: 'Fútbol', icon: sportFutbol },
    BASK: { name: 'Baloncesto', icon: sportBaloncesto },
    AMFO: { name: 'Fútbol Americano', icon: sportFutbolAmericano },
    BASE: { name: 'Béisbol', icon: sportBeisbol },
    MTR: { name: 'Fórmula 1', icon: sportFormula1 },
    TNS: { name: 'Tenis', icon: sportTenis }
  };

  // Si no hay deporte seleccionado o la tab no está activa, no mostrar nada
  if (!selectedSport || !isActive) {
    return null;
  }

  // Verificar si hay contenido en los datos filtrados
  const hasContent = filteredData?.sports?.length > 0;

  // Si no hay contenido después de filtrar, mostrar mensaje
  if (!hasContent) {
    const sport = SPORTS_MAP[selectedSport];
    const sportIcon = sport?.icon || calendario;
    const sportName = sport?.name || selectedSport;
    
    return (
      <div className="empty-state-container">
        <div className="empty-state-content">
          <img className="empty-state-icon" src={sportIcon} alt={sportName}/>
          <h3 className="empty-state-title">No hay eventos</h3>
        </div>
      </div>
    );
  }

  return null;
}